<template>
	<div id="organizador-evento">
		<div class="evento-content">
			<nav class="evento-nav">
				<div class="evento-nav-item" :class="$route.name === 'organizador-evento-estadisticas' ? 'active' : ''" @click.prevent="setTab('organizador-evento-estadisticas')" v-if="orAc.Permisos.includes('VerEstadisticasEvento')">Estadísticas</div>
				<div class="evento-nav-item" :class="$route.name === 'organizador-evento-tickets' ? 'active' : ''" @click.prevent="setTab('organizador-evento-tickets')" v-if="orAc.Permisos.includes('VerTickets')">Tickets</div>
				<div class="evento-nav-item" :class="$route.name === 'organizador-evento-cortesias' ? 'active' : ''" @click.prevent="setTab('organizador-evento-cortesias')" v-if="orAc.Permisos.includes('VerCortesias')">Cortesías</div>
				<div class="evento-nav-item" :class="$route.name === 'organizador-evento-promotores' ? 'active' : ''" @click.prevent="setTab('organizador-evento-promotores')" v-if="orAc.Permisos.includes('VerPromotores')">Promotores</div>
			</nav>
			<div class="evento-main">
				<router-view name="organizadorevento" :key="key"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters }  from 'vuex';

	export default {
		data(){
			return{
				key: 0,
			}
		},
		computed: {
			...mapGetters('AuthModule', ['orAc']),
		},
		methods: {
			async setTab(tab){
				if(tab === this.$route.name){
					this.key = this.key + 1
				} else {
					this.$router.push({ name: tab })
				}
			}
		}
	}
</script>

<style lang="scss">
	.tab-content{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		.dashboard-tab-loader{
			width: 100%;
			@include flex(row, center, center);
			margin: 40px 0px;
		}

		.tab-main{
			width: 100%;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr 1fr;
			grid-gap: 24px;

			.column{
				@include flex(column, flex-start, flex-start);
				height: 100%;

				&.w-50{
					grid-column: 1/3;
				}

				&.w-75{
					grid-column: 1/4;
				}

				.evento-nombre-competencia{
					padding: 14px;
					padding-left: 0px;
					width: 100%;
					@include flex(column, flex-start, flex-start);

					.evento-nombre{
						font-weight: var(--fw-700);
						font-size: 18px;
						line-height: 1.2em;
						margin-bottom: 8px;
						padding-left: 12px;
						border-left: 6px solid var(--color-grey);
					}

					.competencia-nombre{
						font-weight: var(--fw-600);
						font-size: 15px;
						color: var(--color-grey);
						line-height: 1em;
						margin-bottom: 4px;
						padding-left: 18px;
					}
				}

				.card{
					position: relative;
					border-radius: 12px;
					width: 100%;
					height: 100%;
					box-shadow: 0 8px 20px rgba(0,0,0,.13);
					@include flex(column, flex-start, flex-start);

					.card-title{
						width: 100%;
						padding: 15px 20px;
						font-size: 18px;
						font-weight: var(--fw-700);
						line-height: 1;
						@include flex(row, space-between, center);
						border-bottom: 1px solid #ededed;

						.actualizar{
							@include flex(row, flex-end, center);
							cursor: pointer;
							transition: all .2s;
							padding: 3px 0px 3px 3px;

							i{
								font-size: 22px;
							}

							&:hover{
								i{
									color: var(--color-grey)
								}
							}
						}
					}

					.card-main{
						width: 100%;
						padding: 20px;
						@include flex(column, space-around, flex-start);
						flex-grow: 1;

						&.card-main-start{
							@include flex(column, flex-start, flex-start);
						}

						.card-main-top{
							width: 100%;
							@include flex(column, center, flex-start);
							padding-bottom: 15px;
							margin-bottom: 15px;
							border-bottom: 1px solid #ededed;

							.cant-tickets{
								color: var(--color-darker);
								font-family: var(--font-inter);
								font-size: 32px;
								font-weight: var(--fw-700);
								line-height: 1em;
								margin-bottom: 2px;

								.cant-capacidad{
									font-size: 18px;
									font-family: var(--font-inter);
									color: var(--color-grey);
								}
							}

							.label{
								font-size: 15px;
								color: var(--color-grey);
								font-weight: var(--fw-600);
								line-height: 1em;
							}
						}

						.card-row{
							width: 100%;
							display: grid;
							grid-template-columns: repeat(2, 1fr);
							grid-auto-rows: 1fr;
							grid-gap: 24px;

							&:last-child{
								margin-bottom: 0px;
							}

							.card-row-dato{
								width: 100%;
								position: relative;
								@include flex(column, center, flex-start);

								i{
									margin-bottom: 5px;
									font-size: 20px;
									color: var(--color-grey);
								}

								.cant-tickets{
									color: var(--color-darker);
									font-family: var(--font-inter);
									font-size: 25px;
									font-weight: var(--fw-700);
									line-height: 1em;
									margin-bottom: 2px;

									.cant-capacidad{
										font-size: 15px;
										font-family: var(--font-inter);
										color: var(--color-grey);
									}
								}

								.label{
									font-size: 13px;
									color: var(--color-grey);
									font-weight: var(--fw-600);
									line-height: 1em;
								}

								&.disabled{
									opacity: .35;

									&:before{
										content: '';
										position: absolute;
										width: 3px;
										height: 110%;
										top: 0;
										left: 6px;
										background-color: var(--color-red-error);
										transform: rotate(60deg);
									}
								}
							}
						}

						.card-main-row{
							width: 100%;
							margin-bottom: 22px;
							position: relative;
							@include flex(row, flex-start, center);

							&:last-child{
								margin-bottom: 0px;
							}

							.card-main-row-right{
								@include flex(column, center, flex-start);
							}

							.cant-tickets{
								color: var(--color-dark);
								font-family: var(--font-inter);
								font-size: 25px;
								font-weight: var(--fw-700);
								line-height: 1em;
								margin-bottom: 2px;

								.cant-capacidad{
									font-size: 15px;
									font-family: var(--font-inter);
									color: var(--color-grey);
								}
							}

							.label{
								font-size: 13px;
								color: var(--color-grey);
								font-weight: var(--fw-600);
								line-height: 1em;
							}

							.cantidad-medio-pago{
								position: absolute;
								top: 50%;
								right: 0;
								transform: translateY(-50%);
								color: var(--color-grey);
								font-weight: var(--fw-500);
								font-size: 16px;
								font-family: var(--font-inter);
								line-height: 1em;
							}

							.card-main-column{
								width: 50%;
								position: relative;
								@include flex(row, flex-start, center);

								&:last-child{
									margin-bottom: 0px;
								}

								.img-wrapper{
									width: 46px;
									height: 46px;
									@include flex(row, center, center);
									margin-right: 12px;
									padding: 7px;
									border-radius: 99%;
									background-color: var(--color-darker);
									
									img{
										object-fit: cover;
									}
								}

								.card-main-column-content{
									@include flex(column, center, flex-start);
								}

								.cant-tickets{
									color: var(--color-darker);
									font-family: var(--font-sora);
									font-size: 25px;
									font-weight: var(--fw-700);
									line-height: 1em;
									margin-bottom: 6px;

									.cant-capacidad{
										font-size: 15px;
										font-family: var(--font-sora);
										color: var(--color-grey);
									}
								}

								.label{
									font-size: 13px;
									color: var(--color-grey);
									font-weight: var(--fw-600);
									line-height: 1em;
								}
							}
						}

						.flow-recaudacion{
							width: 100%;
							@include flex(row, flex-start, center);

							.group{
								width: 25%;
								// margin-right: 22px;
								// padding-right: 22px;
								border-right: 1px solid rgba(0, 0, 0, 0.13);
								@include flex(row, center, center);

								&:last-child{
									margin-right: 0px;
									padding-right: 0px;
									border-right: none;
								}

								img.medio-pago{
									margin-right: 12px;
									height: 30px;
								}

								.organizador{
									border-radius: 8px;
									@include flex(row, center, center);
									width: 38px;
									height: 38px;
									padding: 5px;
									margin-right: 12px;

									img{
										width: 100%;
										height: 100%;
										object-fit: contain;
									}
								}

								.lineup{
									border-radius: 8px;
									@include flex(row, center, center);
									width: 38px;
									height: 38px;
									padding: 5px;
									margin-right: 12px;
									background-color: var(--color-primary);

									img{
										width: 100%;
										height: 100%;
										object-fit: contain;
									}
								}

								.group-info{
									@include flex(column, center, flex-start);

									.monto{
										color: var(--color-dark);
										font-family: var(--font-inter);
										font-size: 20px;
										font-weight: var(--fw-700);
										line-height: 1em;
										margin-bottom: 2px;

										.porcentaje{
											font-size: 12px;
											font-family: var(--font-inter);
											color: var(--color-grey);
											font-weight: var(--fw-600);
										}
									}

									.label{
										font-size: 12px;
										color: var(--color-grey);
										font-weight: var(--fw-400);
										line-height: 1em;
									}
								}

								&.group-big{
									margin-right: 0px;
									padding-right: 0px;

									.group-info{
										.monto{
											font-size: 26px;

											.porcentaje{
												font-size: 15px;
											}
										}

										.label{
											font-size: 14px;
											font-weight: var(--fw-600);
										}
									}
								}

								&.group-left{
									width: 20%;
									@include flex(row, center, center);
									border-right: none;

									.main-bracket{
										width: 32px;
										margin: 0px 0px 0px 16px;
										filter: opacity(20%);
									}
								}

								&.group-unstyled{
									border-right: none;
								}
							}

							.flow-main{
								height: 100%;
								width: 80%;
								@include flex(column, space-between, flex-start);

								.flow-row{
									width: 100%;
									@include flex(row, flex-start, center);
									border: 1px dashed rgba(0, 0, 0, 0.10);
									padding: 16px 0px;
									border-radius: 8px;

									&.flow-row-center{
										height: 76px;
										border: none;
										padding: 0px;
										
										.group{
											height: 100%;
											@include flex(column, center, center);

											&.group-centered{
												position: relative;
												border-right: none;
												
												&:before{
													content: '';
													position: absolute;
													width: 1px;
													height: 100%;
													background-color: #ddd;
													z-index: 1;
												}

												.total-wrapper{
													z-index: 2;
													// width: 50%;
													background-color: #ddd;
													@include flex(column, center, center);
													padding: 4px 8px;
													border-radius: 6px;

													.total-label{
														font-size: 10px;
														font-weight: var(--fw-500);
													}

													.total-centered{
														font-size: 13px;
														font-weight: var(--fw-700);
													}
												}
											}
										}
									}
								}
							}
						}
					}
				}

				.card-asistencia{
					width: 100%;
					padding: 20px 24px 20px 54px;
					box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
					@include flex(row, flex-start, center);
					position: relative;
					border-radius: 12px;

					&.asistencia-total:before{
						content: 'Total';
						position: absolute;
						top: 0;
						left: 0;
						height: 100%;
						width: 30px;
						background-color: var(--color-darker);
						color: var(--color-white);
						text-transform: uppercase;
						font-family: var(--font-inter);
						font-weight: var(--fw-400);
						font-size: 12px;
						letter-spacing: 1px;
						@include flex(row, center, center);
						writing-mode:vertical-lr;
						border-radius: 12px 0px 0px 12px;
					}

					&.asistencia-escaneo:before{
						content: 'Escaneo';
						position: absolute;
						top: 0;
						left: 0;
						height: 100%;
						width: 30px;
						background-color: var(--color-darker);
						color: var(--color-white);
						text-transform: uppercase;
						font-family: var(--font-inter);
						font-weight: var(--fw-400);
						font-size: 12px;
						letter-spacing: 1px;
						@include flex(row, center, center);
						writing-mode:vertical-lr;
						border-radius: 12px 0px 0px 12px;
					}

					.asistencia-left{
						margin-right: 30px;
						@include flex(column, center, flex-start);

						.cant-tickets{
							color: var(--color-darker);
							font-family: var(--font-inter);
							font-size: 32px;
							font-weight: var(--fw-700);
							line-height: 1em;
							margin-bottom: 2px;

							.cant-capacidad{
								font-size: 18px;
								font-family: var(--font-inter);
								color: var(--color-grey);
							}
						}

						.label{
							font-size: 15px;
							color: var(--color-grey);
							font-weight: var(--fw-600);
							line-height: 1em;
						}
					}

					.porcentaje-asistencia{
						position: relative;
						@include flex(column, center, center);
						background: var(--color-white);

						.percent{
							position: relative;
							width: 80px;
							height: 80px;

							svg{
								position: relative;
								width: 80px;
								height: 80px;

								circle{
									width: 80px;
									height: 80px;
									fill: none;
									stroke-width: 6;
									transform: translate(5px, 5px);
									stroke-dasharray: 213;
									stroke-dashoffset: 213;
									stroke-linecap: round;
									

									&:nth-child(1){
										stroke-dashoffset: 0;
										stroke: #f3f3f9;
									}

									&:nth-child(2){
										stroke: #0071e0;
										animation: animate-circle 1s cubic-bezier(0,0.23,1,.1);
									}
								}
							}

							@keyframes animate-circle {
								0% {
								opacity: 0;
								stroke-dashoffset: 213;
								}
								30% {
								opacity: 0.30;
								stroke-dashoffset: 150;
								}
								80% {
								opacity: 0.80;
								stroke-dashoffset: 80;
								}
								100% {
								opacity: 1;
								}
							}

							.number{
								position: absolute;
								top: 0;
								left: 0;
								width: 100%;
								height: 100%;
								@include flex(row, center, center);
								color: var(--color-darker);
								line-height: 1;

								h2{
									font-size: 16px;
									margin: 0;
									line-height: 1;

									span{
										font-size: 13px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.tb{
		width: 100%;
		
		.tb-header{
			width: 100%;
			padding: 0 15px;
			border-bottom: 1px solid #ddd;
			@include flex(row, flex-start, center);

			.tb-header-th{
				padding: 8px 0;
				font-size: 11px;
				font-weight: var(--fw-700);
				font-family: var(--font-family-poppins);
				letter-spacing: 0.5px;
				text-transform: uppercase;
				@include flex(row, flex-start, center);

				i{
					font-size: 17px;
				}

				.tb-header-th-info{
					margin-left: 3px;
					font-size: 14px;
				}
			}
		}

		.tb-body{
			width: 100%;
			padding: 0;

			.tb-body-row{
				width: 100%;
				padding: 0 15px;
				@include flex(row, flex-start, center);
				border-bottom: 1px solid #e2e5f1;
				@include transition(all .2s);
				// cursor: pointer;

				&.tb-body-row-ticket{
					cursor: pointer;
					
					&:hover{
						opacity: 0.8;
					}

					&:nth-child(even) {
						background-color: #f2f4f8;
					}
				}

				.tb-body-td{
					padding: 10px 0;
					font-size: 13px;
					position: relative;
					z-index: 1;

					&.tb-body-td-sector{
						@include flex(column, center, flex-start);

						.tribuna{
							font-size: 11px;
							font-weight: var(--fw-400);
							line-height: 1em;
							margin-bottom: 3px;
						}

						.sector{
							font-size: 13px;
							font-weight: var(--fw-600);
							line-height: 1em;
						}
					}

					&.tb-body-td-estado{
						@include flex(row, center, center);

						span{
							font-weight: var(--fw-700);
							font-size: 11px;
							text-transform: uppercase;
							line-height: 1em;
							padding: 4px 8px;
							border-radius: 4px;
							background-color: #b8e994;

							&.cancelado, &.inactivo{
								color: var(--color-red-error);
								background-color: #fcddde;
							}

							&.pagando{
								background-color: #f2f4f8;
								color: var(--color-darker);
							}
						}
					}

					&.tb-body-td-transaccion{
						@include flex(row, flex-start, center);

						.copiar-transaccion{
							@include flex(row, center, center);
							padding: 0px 8px;

							i{
								color: var(--color-darker);
								font-size: 14px;
							}
						}
					}

					&.tb-body-td-link{
						@include flex(row, center, center);
						cursor: pointer;

						i{
							font-size: 18px;
							color: var(--color-blue-link);
						}

						&.red{
							i{
								color: var(--color-red-error);
							}
						}

						&.black{
							i{
								color: var(--color-darker);
							}
						}
					}

					&.tb-body-td-copy-link{
						@include flex(row, center, center);
						cursor: pointer;
						@include transition(all .2s);

						div{
							@include flex(row, center, center);
							padding: 4px 8px;
							background-color: #f2f4f8;
							border-radius: 4px;
							font-size: 12px;
							font-weight: var(--fw-600);
							letter-spacing: -0.3px;

							i{
								font-size: 14px;
								color: var(--color-darker);
								margin-right: 3px;
							}
						}
					}

					a{
						text-decoration: underline;
						color: var(--color-darker);
					}

					.porcentaje-acceso{
						position: absolute;
						height: 75%;
						border-radius: 4px;
						left: 0;
						top: 12.5%;
						background-color: #b8e994;
						z-index: -1;

						&.porcentaje-naranja{
							background-color: rgba(253, 150, 68, 0.6);
						}

						&.porcentaje-rojo{
							background-color: rgba(252, 92, 101, 0.8);
						}
					}
				}

				&:last-child{
					border-bottom: none;
				}

				&:hover{
					background-color: #f7f8f9;
				}

				&.no-results{
					padding: 14px 10px;
					margin-top: 7px;
					@include flex(row, center, center);
					cursor: auto;

					span{
						font-weight: var(--fw-400);
						font-style: italic;
					}

					&:hover{
						background: none;
					}
				}
			}
		}
	}
</style>

<style lang="scss" scoped>
	#organizador-evento{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		.evento-content{
			width: 100%;

			nav.evento-nav{
				width: 100%;
				border-bottom: 1px solid #d2dde0;
				@include flex(row, flex-start, center);

				.evento-nav-item{
					@include flex(row, center, center);
					padding: 0px 8px;
					font-size: 13px;
					font-weight: var(--fw-500);
					line-height: 1em;
					height: 42px;
					margin: 0px 8px;
					user-select: none;
					cursor: pointer;
					@include transition(all .2s);

					&:hover{
						opacity: 0.9;
					}

					&.active{
						margin-bottom: -1px;
						color: var(--color-blue-link);
						font-weight: var(--fw-600);
						border-bottom: 3px solid var(--color-blue-link);
					}
				}
			}

			.evento-main{
				width: 100%;
				@include flex(column, flex-start, flex-start);
				padding-top: 20px;
			}
		}
	}
</style>